import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.3416 9.16669H3.33331V10.8334H13.3416V13.3334L16.6666 10L13.3416 6.66669V9.16669Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
